import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material';
var CustomMatPaginatorIntl = /** @class */ (function (_super) {
    tslib_1.__extends(CustomMatPaginatorIntl, _super);
    function CustomMatPaginatorIntl(translate) {
        var _this = _super.call(this) || this;
        _this.translate = translate;
        _this.rangeLabel = function (page, pageSize, length) {
            var off = 'of';
            var to = 'to';
            var enteries = 'enteries';
            var showing = 'showing';
            var totalPages = 'count of pages:';
            var lang = _this.translate.currentLang;
            if (lang == 'ar') {
                off = 'من';
                to = 'إلى';
                enteries = 'إدخالات';
                showing = 'إظهار';
                totalPages = 'عدد الصفحات';
            }
            if (length == 0 || pageSize == 0) {
                return "0 " + off + " " + length;
            }
            length = Math.max(length, 0);
            var startIndex = page * pageSize;
            var pageCount = Math.ceil(length / pageSize);
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            var endIndex = startIndex < length ?
                Math.min(startIndex + pageSize, length) :
                startIndex + pageSize;
            if (lang != 'ar') {
                return showing + " " + (startIndex + 1) + " " + to + " " + endIndex + " " + off + " " + length + " " + enteries + " - " + totalPages + " " + pageCount;
            }
            else {
                return totalPages + " " + pageCount + "\n           -   " + showing + " " + (startIndex + 1) + " " + to + " " + endIndex + " " + off + " " + length + " " + enteries;
            }
        };
        _this.translate.onLangChange.subscribe(function (e) {
            _this.getPaginatorIntl();
        });
        _this.getPaginatorIntl();
        return _this;
    }
    CustomMatPaginatorIntl.prototype.getPaginatorIntl = function () {
        var lang = this.translate.currentLang;
        var itemsPerPageLabel = 'items per page:';
        var nextPageLabel = 'next page';
        var previousPageLabel = 'previous page';
        var firstPageLabel = 'first page';
        var lastPageLabel = 'last page';
        if (lang == 'ar') {
            itemsPerPageLabel = 'عدد السجلات بالصفحة:';
            nextPageLabel = 'الصفحة التالية';
            previousPageLabel = 'الصفحة السابقة';
            firstPageLabel = 'الصفحة الأولى';
            lastPageLabel = 'الصفحة الأخيرة';
        }
        this.itemsPerPageLabel = itemsPerPageLabel;
        this.nextPageLabel = nextPageLabel;
        this.previousPageLabel = previousPageLabel;
        this.firstPageLabel = firstPageLabel;
        this.lastPageLabel = lastPageLabel;
        this.getRangeLabel = this.rangeLabel;
        this.changes.next();
    };
    return CustomMatPaginatorIntl;
}(MatPaginatorIntl));
export { CustomMatPaginatorIntl };
